var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWirelessClient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0gkicn1aka)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.117 6.792H3.87a1 1 0 0 0-1 1v9.434a1 1 0 0 0 1 1h15.632a1 1 0 0 0 1-1V11.079",
    stroke: "#545454",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.198 21.125v-1h-1v1h1zm20.788 0h1v-1h-1v1zm0 .52v1a1 1 0 0 0 1-1h-1zm-20.788 0h-1a1 1 0 0 0 1 1v-1zm6.236-.52.707-.707-.293-.293h-.414v1zm8.316 0v-1h-.414l-.293.293.707.707zm-.52.52v1h.414l.293-.293-.707-.707zm-7.276 0-.707.707.293.293h.414v-1zm14.032-.52h-1v.52h2v-.52h-1zm0 .52v-1H1.198v2h20.788v-1zm-20.788 0h1v-.52h-2v.52h1zm0-.52v1h5.197v-2H1.198v1zm5.197 0v1h1.04v-2h-1.04v1zm10.394 0v1h5.197v-2H16.79v1zm-1.04 0v1h1.04v-2h-1.04v1zm0 0-.706-.707-.52.52.707.707.707.707.52-.52-.707-.707zm-.519.52v-1H7.954v2h7.276v-1zm-7.276 0 .707-.707-.52-.52-.707.707-.707.707.52.52.707-.707zM14.74 11.115a1.04 1.04 0 1 1-2.078 0 1.04 1.04 0 0 1 2.079 0z",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.77 4.609a5.835 5.835 0 0 1 3.763.73 5.835 5.835 0 0 1 2.513 2.893M13.59 1.237a8.475 8.475 0 0 1 5.695 1.026 8.475 8.475 0 0 1 3.735 4.42M13.927 7.97a3.194 3.194 0 0 1 1.82.424c.555.32 1.002.797 1.277 1.365",
    stroke: "#545454",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "0gkicn1aka"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWirelessClient);
export default __webpack_public_path__ + "static/media/wirelessClient.9baed7d27b6db09b7d4339f1b8e96f90.svg";
export { ForwardRef as ReactComponent };